<div class="flex-left-column light-control-host">
  <div class="modal-header">
    <h3 class="panel-title">Failback for "{{ appName }}"</h3>
    <button
      type="button"
      class="modal-close-btn"
      (click)="onCancelClick()"
      pTooltip="Close"
      tooltipPosition="left"
      aria-label="Close"
    >
      <svg lucideX></svg>
    </button>
  </div>
  <div class="modal-subtitle">
    A <strong class="font-semibold">failback</strong> is the reverse of a failover. It copies the data from your
    recovery environment to your existing infrastructure in the primary environment. A failback does not impact the
    application running in the recovery environment, so you can test failback as many times as you like. For more
    details, see the <a href="{{ failbackDocsUrl }}" target="_blank">failback documentation</a>.
  </div>

  <div class="modal-step">
    <div class="modal-step-label">
      <span class="modal-step-number"></span>
      <h3 class="modal-step-title">Applications</h3>
      @if (applications.length > 0) {
        <div class="modal-step-actions">
          <span class="selection-count">
            <strong>{{ selectedApplications.length }}</strong> of {{ applications.length }} selected
          </span>
          <button
            type="button"
            class="select-all-link"
            (click)="toggleSelectAllApplications(!areAllApplicationsSelected())"
          >
            {{ areAllApplicationsSelected() ? 'Deselect all' : 'Select all' }}
          </button>
        </div>
      }
    </div>

    @if (applications.length === 0) {
      <div class="app-selection-empty">
        <svg lucideInfo></svg>
        <span>No applications are available to failback.</span>
      </div>
    }

    @if (applications.length > 0) {
      <div class="app-selection-list" id="applicationSelectionList">
        @for (application of applications; track application) {
          <label class="app-selection-row" [class.selected]="applicationIsChecked(application.applicationObj)">
            <input
              class="arpio-checkbox"
              type="checkbox"
              (input)="toggleApplicationSelection(application.applicationObj.applicationId)"
              [checked]="applicationIsChecked(application.applicationObj)"
            />
            <span class="app-name">{{ application.applicationObj.name }}</span>
          </label>
        }
      </div>
    }
  </div>

  <div class="modal-step">
    <div class="modal-step-label">
      <span class="modal-step-number"></span>
      <h3 class="modal-step-title">Failback access</h3>
    </div>

    @if (loading) {
      <div class="failback-access-loading">
        <svg lucideLoaderCircle class="lucide-spin"></svg>
        <span>Checking for AWS connectivity</span>
      </div>
    } @else {
      @if (failbackAccessInitiallyAllGood) {
        <div class="modal-subtitle">It looks like Arpio already has the right access to perform a failback.</div>
      } @else {
        @if (!failbackAccessInitiallyAllGood) {
          <div class="modal-subtitle">
            Arpio needs some extra permissions for your environment to failback. You can remove these later.
          </div>
        }
        <aws-account-access-view
          [state]="failbackAccessService.state"
          [stackName]="failbackAccessService.stack"
          [accessType]="Scope.FAILBACK"
          [templateUrl]="failbackAccessTemplate"
          [awsAccountId]="application.sourceAwsAccountId"
          [region]="application.sourceRegion"
          [completedTestCount]="failbackAccessService.tests"
          (buttonClicked)="failbackAccessService.validateAccess()"
        >
        </aws-account-access-view>
      }
    }
  </div>

  <div class="modal-footer">
    <button class="arpio-secondary-button" (click)="onCancelClick()" [disabled]="launching">Cancel</button>
    <button
      busy-button
      id="failback-button"
      class="arpio-button"
      [busy]="launching"
      [disabled]="notReadyToFailback || launching"
      (click)="onFailbackClick()"
    >
      Failback
    </button>
  </div>
</div>
